import React from "react";

function SvgInsuranceCover({
  color = "currentColor",
  width = 20,
  height = 20,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M7.8125 9.0625C7.8125 7.85531 8.79281 6.875 10 6.875C11.2072 6.875 12.1875 7.85531 12.1875 9.0625C12.1875 7.85531 13.1678 6.875 14.375 6.875C15.5822 6.875 16.5625 7.85531 16.5625 9.0625C16.5625 5.44062 13.6219 2.5 10 2.5C6.37812 2.5 3.4375 5.44062 3.4375 9.0625C3.4375 7.85531 4.41781 6.875 5.625 6.875C6.83219 6.875 7.8125 7.85531 7.8125 9.0625Z"
        stroke={color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 12.8125C12.5 12.2947 12.0803 11.875 11.5625 11.875C10.6691 11.875 9.33094 11.875 8.4375 11.875C7.91969 11.875 7.5 12.2947 7.5 12.8125C7.5 13.4437 7.5 14.29 7.5 15.0159C7.5 15.9387 8.04125 16.7756 8.88281 17.1537C9.46062 17.4137 10 17.6562 10 17.6562C10 17.6562 10.5394 17.4137 11.1172 17.1537C11.9588 16.7756 12.5 15.9387 12.5 15.0159C12.5 14.29 12.5 13.4437 12.5 12.8125Z"
        stroke={color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.98438 14.6094L9.76562 15.2344L11.0156 14.1406"
        stroke={color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.875V10.9375"
        stroke={color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.81039 8.28125C7.81039 8.28125 7.15976 5.33812 9.99789 2.5"
        stroke={color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1567 8.28153C12.1567 8.28153 12.4651 4.85536 10.2188 2.75391"
        stroke={color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgInsuranceCover;
